import {
  ISearchUserReq,
  ISearchUserRes,
  IUser,
  IUserResetPassword,
} from '../interfaces/user';
import * as baseAdapter from './baseAdapter';

export const searchUsers = async (req: ISearchUserReq) => {
  const ret = await baseAdapter.post<ISearchUserRes>('/user/gets', req);
  return ret;
};

export const addUser = async (body: Partial<IUser>) => {
  const ret = await baseAdapter.post<Partial<IUser>>('/user/create', body);
  return ret;
};

export const editUser = async (id: string, body: Partial<IUser>) => {
  const ret = await baseAdapter.put('/user/update/' + id, body);
  return ret;
};

export const deleteUser = async (id: string) => {
  const ret = await baseAdapter.deletes('/user/deleteuser/' + id);
  return ret;
};

export const resetPassword = async (data: IUserResetPassword) => {
  const ret = await baseAdapter.post('/user/resetpassword', data);
  return ret;
};
